import {
    LinkedEntity,
    createEntityExtension,
} from "../mystekz-linked-entities";
import { BusinessEntitiesManager } from "./manager";
import { type BusinessEntity } from "@/stores/business-entities-store";
import { h } from "vue";
import { vnodeToHtml } from "@/utils";
import GenericCard from "@/components/EntityInfo/GenericCard.vue";
import { EntityType } from "@/stores/entity-store";

export type BusinessEntityEntity = LinkedEntity<
    "domain-object",
    BusinessEntity
>;

let businessEntityManager: BusinessEntitiesManager;
/**
 * Get the business entity manager for a given domain.
 */
export const getBusinessEntitiesManager = (_: string) => {
    if (!businessEntityManager) {
        businessEntityManager = new BusinessEntitiesManager();
    }
    return businessEntityManager;
};

/**
 * Show an inline menu for creating entities, or linking to existing entities.
 * Also adds popups on hover with information for those entities.
 */
export const BusinessEntitiesExtension = createEntityExtension(
    "business_entity",
    "",
    false,
    {
        popup: {
            key: "businessEntityDetails",
            hover: true,
            create: (
                _: Promise<BusinessEntityEntity | void>,
                entityId: string
            ) => {
                return () => {
                    return vnodeToHtml(
                        h(GenericCard, {
                            entityId,
                            entityType: EntityType.BUSINESS_ENTITY,
                        })
                    );
                };
            },
        },
        prefix: "",
    },
    {
        popup: {
            key: "businessEntityInsert",
        },
        prefix: "[",
    },
    getBusinessEntitiesManager,
    {
        label: "Definitions",
        showInInlineMenu: true,
        caret: true,
        icon: {
            name: "plus-square",
        },
        group: "Linked Entities",
    }
);
